<template functional>
	<li class="page-tab" :class="data.staticClass || ''">
		<router-link :to="props.to" v-if="props.to !== null" class="page-tab-label">
			<slot></slot>
		</router-link>

		<span class="page-tab-label" v-else>
			<slot></slot>
		</span>
	</li>
</template>

<script>
export default {
	props: {
		to: { default: null },
		active: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss">
@import '../variables';

.page-tab {
	display: inline-block;

	.page-tab-label {
		display: block;
		padding: 10px 20px;
		color: black;
		text-decoration: none;

		&.router-link-exact-active,
		&.active {
			color: white;
			background-color: $blue;
			color: white;

			&a {
				&:hover {
					background-color: $dark-blue;
				}
			}
		}
	}

}
</style>
